import React from 'react';
import { number } from 'prop-types';
import { quotesPropType } from '../../utils/propTypes';
import QuotesCompactList from './QuotesCompactList';
import QuotesCarousel from './QuotesCarousel';
import { showAboveSmBreakpoint, showBelowSmBreakpoint } from '../../constants/responsiveClassNames';

const QuotesNoTabsView = ({ quotes, maxListSize }) => {
  return (
    <>
      <div className={showBelowSmBreakpoint}>
        <QuotesCompactList quotes={quotes} maxListSize={maxListSize} />
      </div>
      <div className={showAboveSmBreakpoint}>
        <QuotesCarousel quotes={quotes} />
      </div>
    </>
  );
};

QuotesNoTabsView.propTypes = {
  maxListSize: number,
  quotes: quotesPropType.isRequired,
};
QuotesNoTabsView.defaultProps = {
  maxListSize: 3,
};

export default QuotesNoTabsView;